//import logo from './logo.svg';
import HomePage from './page/HomePage';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css'



import './App.css';
import AboutMePage from './page/AboutMePage';
import Routing from './Routing';

function App() {
  return (


    <Routing />




  )
}

export default App;
